import React from 'react';
import { observer } from 'mobx-react-lite';
import { useDependencies } from '@servicetitan/react-ioc';
import { ServiceFinanceStore } from '../../../../stores/service-finance.store';
import { CoApplicant } from './co-applicant';
import { Stack } from '@servicetitan/design-system';

export const AddCoApplicantInfoPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    const loan = store.applicationForm!.$.Loan;
    const desiredLoanAmount =
        loan.$.SalesAmount.value && loan.$.DownPayment.value
            ? parseFloat(loan.$.SalesAmount.value) - parseFloat(loan.$.DownPayment.value)
            : 0;

    return (
        <React.Fragment>
            <Stack direction="column" justifyContent="flex-start" className="m-y-2 page-content">
                <Stack.Item>
                    <CoApplicant
                        coApplicant={store.applicationForm!.$.CoApplicant}
                        primaryAddress={store.applicationForm!.$.PrimaryApplicant.$.HomeAddress}
                        hasCoApplicant={store.applicationForm!.$.hasCoApplicant}
                        states={store.getStates()}
                        validate={store.validateField}
                    />
                </Stack.Item>
            </Stack>
        </React.Fragment>
    );
});
